module.exports = __webpack_public_path__ + "static/img/duoxuan.bad197f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourse/duoxuan.png
// module id = gZCb
// module chunks = 96